// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const READ_WHOLE_REVIEW = "\u010c\u00edtaj cel\u00e9...";
export const REVIEW_OF_ALIKE_MODEL_stroller = "Recenzia s\u00favisiaceho modelu %(stroller)s";
export const REVIEW_VERIFIED = "Overen\u00e1 recenzia";
export const STROLLERS_DETAILED_REVIEW = "Podrobn\u00e1 recenzia";
export const STROLLERS_NOT_APPROVED = "\u010dak\u00e1 na kontrolu";
